import {List, Radio, Spin} from "@arco-design/web-react";
import styles from "./index.module.less";
import { Article } from "../index";
import { userSelf, category, post, homeList,homeList2 } from "../../store";
import useTouchBottom from "../../hooks/useTouchBottom";
import { isHiddenPostStatus } from "../../utils";
import { useEffect, useState } from "react";
import { List as ListStore } from "../../store/List";
import { observer } from "mobx-react-lite";

// 审核不通过(-3)/被举报下架(-1)/待人工审核隐藏(3) 的内容在 Web 端一律不可见（包括作者
// 自己的「我的发布」列表）。后端 userlist 对作者本人会下发 -3/-1（App 端展示角标依赖此
// 行为），Web 端因详情页带分享二维码/链接、无法做分享隔离，按产品要求在展示层整条隐藏。
export const isVisibleToViewer = item => !isHiddenPostStatus(item?.status);

export default observer(function ({
  showCategory,
  path = "/api/v1/post/list",
  query = {},
  tab,
  method = "post",
    cursorKey="createdAt"
}) {
  const [store] = useState(new ListStore(path,{
      method,
      cursorKey
  }));
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const loadmore = async () => {
    if (tab && post.activeTab !== tab) return;
    if ("user" in query && !query.user) return;
    const visibleCount = arr => arr.filter(isVisibleToViewer).length;
    let data = await store.loadmore(query);
    // 一页可能整页被 -1/-3 过滤掉（作者连续多条内容被处理），视觉上没加载出新内容、
    // 触底事件也不会再触发；可见条数没有增长且服务端还有更多时自动补拉。
    // 上限 5 页 + 无新增即停，防请求失败或极端数据时空转
    let guard = 0;
    while (guard < 5 && store.hasMore && visibleCount(data) === visibleCount(list)) {
      const before = data.length;
      data = await store.loadmore(query);
      guard++;
      if (data.length === before) break;
    }
    setList(data);
  };
  useEffect(() => {
    loadmore().then(() => {
      setLoading(false);
    });
  }, [query.user]);

  const handleDeleteClick = (item) => {
    setList((list) => list.filter((o) => o.id !== item.id));
  };

  useTouchBottom(loadmore);
  return (
    <List
      bordered={false}
      loading={loading}
      footer={store.loading && list.length > 0 && <Spin />}
      className={`${styles.postList} ${!tab && styles.paddingTop}`}
    >
      {list.filter(isVisibleToViewer).map((item, index) => {
        return (
          <List.Item key={index}>
            <Article
              showCategory={showCategory}
              item={item}
              onDelete={handleDeleteClick.bind(this, item)}
              self={item?.user?._id === userSelf.id}
              showDelete={tab === "mypost"}
            />
          </List.Item>
        );
      })}
    </List>
  );
});

export const HomeList = observer(() => {
    // type 1 文章，2 动态
    const [postType,setPostType]=useState(1)
  return (
      <div className={`${styles.postList} ${styles.paddingTop}`}>
        <div className={styles.radioGroup}>
            <Radio.Group
                type='button'
                name='lang'
                value={postType}
                onChange={setPostType}
            >
                <Radio value={1}>推文</Radio>
                <Radio value={2}>动态</Radio>
            </Radio.Group>
        </div>
          <List bordered={false} style={{display:postType===1?undefined:'none'}}>
              {homeList.list.map((item, index) => {
                  return (
                      <List.Item key={index}>
                          <Article
                              showCategory
                              item={item}
                              self={item.user?.id === userSelf.id}
                          />
                      </List.Item>
                  );
              })}
          </List>
          <List bordered={false} style={{display:postType===2?undefined:'none'}}>
              {homeList2.list.map((item, index) => {
                  return (
                      <List.Item key={index}>
                          <Article
                              showCategory
                              item={item}
                              self={item.user?.id === userSelf.id}
                          />
                      </List.Item>
                  );
              })}
          </List>
      </div>

  );
});
